module.exports = __webpack_public_path__ + "img/activity_type.63ff9031.png";